import React, { useEffect, useState } from 'react';
import { CONTENT_ITEMS } from '../../model/content-items';
import { getContent } from '../../helpers/content-helper';
import { styled } from 'styled-components';
import { Headlines } from 'gocclr-shared-ui/dist/styles/styled/typography';
import { Button } from 'gocclr-shared-ui/dist/elements';
import { accountsMedia } from '../../styles/bootstrap-breakpoints';
import { MediumMediaQuery } from '../shared/boostrap-media-query';
import { Container } from 'styled-bootstrap-grid';
import Skeleton from 'react-loading-skeleton';

const Title = styled.h1`
    color:${props => props.theme.colors.text.blue};
    font-weight: 850;
    font-style: normal;
    font-size: 34px;
    margin-bottom: 1.875rem;
    ${Headlines}
`;

const Paragraph = styled.p`
    color:${props => props.theme.colors.primary};
    font-weight: 400;
    font-style: normal;
    font-size: 14px;
`;

const CallToActionContainer = styled.div`
    width: 100%;
    margin-bottom: 1rem;
    margin-top: 7rem;
    display: flex;
    flex-direction: row;
    gap: 0.4rem;
    justify-content: flex-end;

    && {
        button.button {
            width: 19rem;
        }
    }

    ${accountsMedia.lessThan('Medium')`
        flex-direction: column;
        gap: 0.5rem;
        align-items: center;

        && {
            button.button{
                width: 100%;
            }
        }
    `}
`;

export interface AcknowledgementTermsAndConditionsRenderContent {
    title: string;
    description: string;
    agreeLabel: string;
    disagreeLabel: string;
}

export interface AcknowledgementTermsAndConditionsRenderProps {
    isLoading?: boolean;
    onDisagree?: (event?: React.MouseEvent<Element, MouseEvent> | React.KeyboardEvent<Element>) => void;
    onAgree?: () => void;
}

export function AcknowledgementTermsAndConditionsRender(props: AcknowledgementTermsAndConditionsRenderProps) {
    const { isLoading, onAgree, onDisagree } = props;
    const [content, setContent] = useState<AcknowledgementTermsAndConditionsRenderContent>();

    useEffect(() => {
        getContent<AcknowledgementTermsAndConditionsRenderContent>(CONTENT_ITEMS.ACKNOWLEDGEMENT_TERMS_AND_CONDITIONS).then(c => {
            setContent(c);
        });

    }, []);

    function acknowledgementTermsSkeleton() {
        return (
            <Container>
                <Title><Skeleton width="60%" height={37} /></Title>
                <Paragraph>
                    <Skeleton width="97%" height={20} count={5} />
                </Paragraph>
                <CallToActionContainer>
                    <MediumMediaQuery>
                        {(isDesktop: boolean) => {
                            if (isDesktop) {
                                return (
                                    <>
                                        <Skeleton width={'250px'} height={43} />
                                        <Skeleton width={'250px'} height={43} />
                                    </>
                                );
                            }
                            return (
                                <>
                                    <Skeleton width={'380px'} height={43} />
                                    <Skeleton width={'380px'} height={43} />
                                </>
                            );
                        }
                        }
                    </MediumMediaQuery >
                </CallToActionContainer >
            </Container>
        );
    }

    if (!content || isLoading) {
        return acknowledgementTermsSkeleton();
    }

    return (
        <Container>
            <Title>{content.title}</Title>
            <Paragraph>{content.description}</Paragraph>
            <CallToActionContainer>
                <MediumMediaQuery>
                    {(isDesktop: boolean) => {
                        if (isDesktop) {
                            return (
                                <>
                                    <Button styleType="inverted" onClick={onDisagree} >{content?.disagreeLabel}</Button>
                                    <Button type='submit' onClick={onAgree}>{content?.agreeLabel}</Button>
                                </>
                            );
                        }
                        return (
                            <>
                                <Button type='submit' onClick={onAgree}>{content?.agreeLabel}</Button>
                                <Button styleType="inverted" onClick={onDisagree}>{content?.disagreeLabel}</Button>
                            </>
                        );
                    }
                    }
                </MediumMediaQuery >
            </CallToActionContainer >
        </Container>
    );
}